module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-paraa"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALSO BY STEVE DUNO")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Choosing a Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Leader of the Pack")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Show Biz Tricks for Cats")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Everything Cat Book")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Anti-Aging for Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Plump Pups and Fat Cats")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Caddie Sense")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Bad Dog!")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("No Kitty!")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The K.I.S.S. Guide to Playing Golf")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The K.I.S.S. Guide to Cats")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Every Dog’s Guide to Living with a Neurotic Owner")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Only Cat Book You’ll Ever Need")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Clever Cat Trick Kit Book")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Amazing Dog Trick Kit Book")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Be the Dog: Secrets of the Natural Dog Owner")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Be the Cat: Secrets of the Natural Cat Owner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79741169","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmattera.vue
// module id = 66
// module chunks = 0